import React from 'react'
import './page-not-found.styles.scss'

import BrandLogo from '@/components/SHARED/brand-logo/brand-logo.component';
import { useNavigate } from 'react-router-dom'

const PageNotFound = () => {

    const navigate = useNavigate();
    
    return (
        <div className="not-found-page">
            <div className="container g-card">
                <div className="image">
                    <BrandLogo theme='hardwood' tone='light' size='hero' />
                </div>
                <div className="content">
                    <h1>404 Page Not Found</h1>
                    <p>The page you are looking for does not exist.</p>
                    <button className='g-button' onClick={() => navigate(-1)}>Back</button>
                </div>
            </div>
        </div>
    )
}

export default PageNotFound